<template>
  <v-card class="align-stretch" height="100%">

    <v-card-title>
      Fault Appointment
      <v-spacer></v-spacer>
      <v-btn color="secondary" x-small :loading="getIsFaultApptEmailLoading" :disabled="getIsFaultApptEmailLoading" @click="sendEmail"><v-icon small>{{emailIcon}}</v-icon></v-btn>
      <v-btn color="secondary" x-small @click="editOpen=true"><v-icon small>edit</v-icon></v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col>

          <p class="mb-1 text-caption">Appointment Date</p>
          <p><b>{{getCurrentProduct.product_details.fault_appt_date | formatDateWithoutTime | customPlaceholder}}</b></p>

          <p class="mb-1 text-caption">Preferred Appt Window</p>
          <p><b>{{getCurrentProduct.product_details.fault_appt_preferred_window | customPlaceholder}}</b></p>

          <p class="mb-1 text-caption">Appointment Reference</p>
          <p><b>{{getCurrentProduct.product_details.fault_appt_ref | customPlaceholder}}</b></p>

        </v-col>
      </v-row>
    </v-card-text>

    <FaultAppointmentDialog v-model="editOpen" />

  </v-card>
</template>

<script>
  import {mapGetters,mapActions} from 'vuex';
  import FaultAppointmentDialog from "./FaultAppointmentDialog";

  import { mdiEmailOutline } from '@mdi/js';
  export default {

    components: {FaultAppointmentDialog},

    data() {
      return {
        editOpen: false,
        emailIcon: mdiEmailOutline
      }
    },

    computed: {
      ...mapGetters('products', ['getCurrentProduct']),
      ...mapGetters('productGeneral', ['getIsFaultApptEmailLoading','getFaultApptEmailError']),
    },

    methods: {
      ...mapActions('productGeneral',['sendFaultApptEmail']),
      ...mapActions('alerts', ['setAlert']),

      async sendEmail() {
        if(confirm('Are you sure you want to send this email?')){
          await this.sendFaultApptEmail(this.getCurrentProduct);
          if(!this.getFaultApptEmailError){
            this.setAlert({type: 'success', message: `Fault appointment email sent`});
          }else{
            this.setAlert({type: 'error', message: this.getFaultApptEmailError});
          }
        }
      }
    },

  }
</script>

<style>

</style>
